import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import { UsuarioService } from '../../../providers/usuario-service';
/*
  Generated class for the ModalAdicionarPergunta page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  templateUrl: 'modal-cria-pca.html'
})
export class ModalCriaPcaPage {
  PCAModel: any = {
    id: 0,
    dsAnoexercicio: "",
    codProtocolo: "",
    dirigente: "",
    responsavel: "",
    jurisdicionado: "",
    idEntidade: "",
    dsEntidade: ""
  };
  user: any;
  idEntidade: any;
  dsEntidade: any;
  listaAnos: any = [];

  listEntidades: any = [];
  listEntidadesAux: any = [];

  order: any = 'dsEntidade';

  constructor(private viewCtrl: ViewController, public navParams: NavParams, public usuarioService: UsuarioService) {
    this.user = this.usuarioService.obtemUsuario();

    this.user.dadosUsuario.forEach(dados => {
      if (this.listEntidadesAux.indexOf(dados.idEntidade) === -1) {
        this.listEntidadesAux.push(dados.idEntidade);
        this.listEntidades.push(dados);
      }
    });

    this.PCAModel.responsavel = this.user.dadosUsuario[0].nome;

    let d = new Date();
    let anoAtual = d.getFullYear();

    this.listaAnos.push(anoAtual - 1);

    /*
    * Alteração realizada para atender o Ticket#-2020062610000465.
    * Essa não é a solução definitiva, enquanto a area de negocio não decide iremos fazer dessa forma.
    *
    * Nao pode criar PCA para o ano corrente.
    */
    //this.listaAnos.push(anoAtual);

  }

  onEntidadeChange(item) {
    this.PCAModel.idEntidade = item.idEntidade;
    this.PCAModel.dsEntidade = item.dsEntidade;
  }

  salvarPCA() {
    this.viewCtrl.dismiss(this.PCAModel);
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-cria-pca/modal-cria-pca.ts